const prefix = 'dagligbank-lokalbank';
export const loansTrackingIDs = {
    editLoan: {
        id: `${prefix}-edit-loan`,
        name: 'edit-loan',
    },
    downpayment: {
        id: `${prefix}-downpayment-loan`,
        name: 'downpayment-loan',
    },
    interestFree: {
        id: `${prefix}-interestFree-loan`,
        name: 'interestFree-loan',
    },
    loanOverview: `${prefix}-loan-overview`,
    loanOverviewError: `${prefix}-loan-overview-error`,
    loanDetails: `${prefix}-loan-details`,
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibG9hbnMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvdXRpbHMvZ3RtL3RyYWNrSURzL2xvYW5zLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE1BQU0sTUFBTSxHQUFHLHNCQUFzQixDQUFDO0FBQ3RDLE1BQU0sQ0FBQyxNQUFNLGdCQUFnQixHQUFHO0lBQzVCLFFBQVEsRUFBRTtRQUNOLEVBQUUsRUFBRSxHQUFHLE1BQU0sWUFBWTtRQUN6QixJQUFJLEVBQUUsV0FBVztLQUNwQjtJQUNELFdBQVcsRUFBRTtRQUNULEVBQUUsRUFBRSxHQUFHLE1BQU0sbUJBQW1CO1FBQ2hDLElBQUksRUFBRSxrQkFBa0I7S0FDM0I7SUFDRCxZQUFZLEVBQUU7UUFDVixFQUFFLEVBQUUsR0FBRyxNQUFNLG9CQUFvQjtRQUNqQyxJQUFJLEVBQUUsbUJBQW1CO0tBQzVCO0lBQ0QsWUFBWSxFQUFFLEdBQUcsTUFBTSxnQkFBZ0I7SUFDdkMsaUJBQWlCLEVBQUUsR0FBRyxNQUFNLHNCQUFzQjtJQUNsRCxXQUFXLEVBQUUsR0FBRyxNQUFNLGVBQWU7Q0FDeEMsQ0FBQyJ9